import React, { useContext } from 'react'
import { navigate } from '@reach/router'
import styled from 'styled-components'

import Call from './Call'
import { UserContext } from '../context/user'
import { ReactComponent as Logo } from '../assets/images/logo.svg'
import { ReactComponent as Arrow } from '../assets/icons/arrow_down.svg'

export default (props) => {
	const _connect = () => navigate('/connect')

	const { state } = useContext(UserContext)

	if (state.connected) return <Call />

	return (
		<Container>
			<Section top>
				<Image />
				<Header>outline</Header>
				<p>Communicate & Collaborate</p>
			</Section>
			<Section>
				<Button onClick={_connect}>
					<p>connect</p>
					<Arrow />
				</Button>
			</Section>
		</Container>
	)
}

const Container = styled.section`
	height: 100%;
	display: flex;
	flex-direction: column;
	background: ${({ theme }) => theme.colors.white};
`
const Section = styled.section<{ top? }>`
	flex: 1;
	text-align: center;
	display: flex;
	flex-direction: column;
	justify-content: ${({ top }) => top && 'flex-end'};
	align-items: center;
`
const Image = styled(Logo)`
	height: 80px;
	width: 80px;
	margin: 1.5rem;
`
const Header = styled.h1`
	font-size: 2rem;
	font-weight: 400;
	margin-bottom: 0.5rem;
`
const Button = styled.button`
	font-size: 0.9rem;
	background: none;
	border: none;
	outline: none;
	align-self: center;
	margin-top: auto;
	margin-bottom: 3rem;
	cursor: pointer;
	color: ${({ theme }) => theme.colors.primary};

	:focus {
		outline: none;
		text-decoration: underline;
	}
`
